import React, {useState, useEffect} from 'react'
import './Help.scss'

const Help = props => {
    return (
        <div className={`Help`}>
            <div className={`task-model-button`} onClick={()=>props.setHelpOpen(false)}>Close Help</div>
        </div>
    )
}

export default Help